<script setup>
/* 定制(2026-09-15): App设置页——手机App登录IP白名单(管理员)。
   白名单为空=不限制; 仅拦App(UA=Chatwoot Mobile)登录, 后台浏览器登录不受限。
   后端 GET/PUT /api/v1/accounts/:id/app_settings */
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import { useMapGetter } from 'dashboard/composables/store';
/* global axios */

const route = useRoute();
const accountId = computed(() => route.params.accountId);
const isAdmin = useMapGetter('getCurrentRole');

const ipsText = ref('');
const loading = ref(true);
const saving = ref(false);

onMounted(async () => {
  if (isAdmin.value !== 'administrator') {
    loading.value = false;
    return;
  }
  try {
    const { data } = await axios.get(
      `/api/v1/accounts/${accountId.value}/app_settings`
    );
    ipsText.value = (data.app_allowed_ips || []).join(', ');
  } catch (e) {
    useAlert('读取设置失败');
  } finally {
    loading.value = false;
  }
});

const save = async () => {
  saving.value = true;
  try {
    const { data } = await axios.put(
      `/api/v1/accounts/${accountId.value}/app_settings`,
      { app_allowed_ips: ipsText.value }
    );
    ipsText.value = (data.app_allowed_ips || []).join(', ');
    useAlert('已保存，立即生效');
  } catch (e) {
    const msg = e?.response?.data?.error || '保存失败';
    useAlert(msg);
  } finally {
    saving.value = false;
  }
};
</script>

<template>
  <div class="overflow-auto bg-n-surface-1 w-full px-6">
    <div class="max-w-3xl mx-auto py-8">
      <div class="bg-n-solid-3 rounded-xl p-6">
        <h1 class="text-2xl font-bold text-n-slate-12">App设置</h1>
        <p class="text-sm text-n-slate-10 mt-2">
          手机App仅允许白名单内的IP登录；白名单留空 =
          不限制。浏览器后台登录不受此限制（出口IP变化后仍可进后台修改）。
        </p>

        <div v-if="isAdmin !== 'administrator'" class="mt-6 text-sm text-n-slate-10">
          仅管理员可查看和修改此设置。
        </div>
        <template v-else>
          <div class="mt-6">
            <label class="block text-sm font-medium text-n-slate-12 mb-2">
              App允许登录IP（多个用逗号分隔）
            </label>
            <input
              v-model="ipsText"
              type="text"
              placeholder="例如: 60.216.47.38"
              :disabled="loading"
              class="w-full px-3 py-2 rounded-lg bg-n-solid-2 border border-n-slate-6 text-sm text-n-slate-12 outline-none focus:border-n-brand"
            />
            <p class="text-xs text-n-slate-8 mt-2">
              保存后立即生效。App用户被拦时会提示联系管理员。
            </p>
          </div>
          <button
            class="mt-4 px-4 py-2 rounded-lg bg-n-brand text-white text-sm font-medium disabled:opacity-50"
            :disabled="loading || saving"
            @click="save"
          >
            {{ saving ? '保存中…' : '保存' }}
          </button>
        </template>
      </div>
    </div>
  </div>
</template>
